<template>
    <div class="circle" :class="class">
        <span>{{ score }}</span>
        <svg viewBox="-1 -1 38 38">
            <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                fill="none"
                stroke="#747474"
                stroke-width="5"
                :stroke-dasharray="percentage + ', 100'"
            />
        </svg>
        <svg viewBox="-1 -1 38 38">
            <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                fill="none"
                stroke="#E9E9E9"
                stroke-width="5"
            />
        </svg>
    </div>
</template>

<script>
export default {
    props: {
        class: {
            required: false,
        },
        score: {
            required: true,
        },
        percentage: {
            type: Number,
            required: true,
        },
    },
}
</script>

<style scoped>
.circle {
    position: relative;
    width: 75px;
    height: 75px;
}

.circle.small {
    width: 38px;
    height: 38px;
}

.circle > span {
    width: 75px;
    height: 75px;
    font-size: 22px;
    line-height: 24px;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
}

.circle.small > span {
    width: 38px;
    height: 38px;
    font-size: 14px;
    line-height: 16px;
}

.circle svg {
    position: absolute;
}

.circle svg:nth-child(1) {
    z-index: 2;
}

.circle svg:nth-child(2) {
    z-index: 1;
}
</style>
